import styles from './styles.module.scss';
import { useSelector, useDispatch } from 'react-redux';
import { setCriteriaSectionInviteFlow } from 'store/effects/app';
import { isCriteriaSectionInviteFlowOPened } from 'store/selectors/app';

interface PropType {
  isValid?: boolean;
  stageIndex: number;
  onPrev?: () => any;
  disabled?: boolean;
}
const InviteHeader = ({ stageIndex, onPrev }: PropType) => {
  const isCriteriaSectionOpened = useSelector(isCriteriaSectionInviteFlowOPened);
  const dispatch = useDispatch();

  const ArrowLeft = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M20 8L12 16L20 24"
        stroke="#515151"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <>
      <div className={styles.headerContanierInvite}>
        {stageIndex > 0 && (
          <>
            {!isCriteriaSectionOpened && (
              <span onClick={onPrev} className={styles.arrowLeft}>
                <ArrowLeft />
              </span>
            )}
            {isCriteriaSectionOpened && (
              <span
                onClick={() => dispatch(setCriteriaSectionInviteFlow(false))}
                className={styles.arrowLeft}
              >
                <ArrowLeft />
              </span>
            )}
          </>
        )}
        <div className={styles.headerInvite}>
          {isCriteriaSectionOpened ? (
            <h2 className={styles.inviteHeading}>Add Search Criteria</h2>
          ) : (
            <h2 className={styles.inviteHeading}>Invite Client</h2>
          )}
        </div>
      </div>
    </>
  );
};

export default InviteHeader;
